exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preparation-datepicker .cell.today {\n  background: #dedede !important;\n}\n.preparation-datepicker .cell.selected {\n  border: 1px solid #888 !important;\n}", ""]);

// exports
